module.exports = __webpack_public_path__ + "img/joinmember_flight.781ee669.png";